import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Person } from '@mui/icons-material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { enUS } from 'date-fns/locale';
import dayjs from 'dayjs';

import ChildSelector from '@/components/Parent/ChildSelector';
import MenuServingTimePicker from '@/components/Parent/MenuServingTimePicker';
import MenuChildOrdersAccordion from '@/components/Parent/MenuChildOrdersAccordion';
import PastAwarePickersDay from '@/components/Order/PastAwarePickersDay';
import { nfRp } from '@/constants/nf';
import { pathDashboard, pathMenu, route } from '@/constants/routeName';

/**
 * Menu / Meal-details ordering chrome matching the preview sticky header.
 */
export default function OrderingHeader({
	title = 'Choose meals',
	backTo = 'dashboard',
	backLabel,
	children,
}) {
	const dispatch = useDispatch();
	const user = useSelector((state) => state.auth.user);
	const selectedCustomer = useSelector((state) => state.auth.selectedCustomer);
	const orderDate = useSelector((state) => state.cart.orderDate);

	const backHref = backTo === 'menu' ? pathMenu : pathDashboard;
	const backText =
		backLabel || (backTo === 'menu' ? 'Back to menu' : 'All children');

	return (
		<>
			<header className='ordering-header' aria-label='Ordering context'>
				<div className='ordering-topline'>
					<Link to={backHref} className='ordering-back'>
						<span aria-hidden='true'>←</span> {backText}
					</Link>
					<div className='ordering-account'>
						<span className='ordering-parentname'>{user?.name || 'Parent'}</span>
						<Link to={`/${route.account}`} className='profile' aria-label='Family account'>
							<Person fontSize='small' />
						</Link>
					</div>
				</div>

				<h1 className='ordering-title'>{title}</h1>

				<ChildSelector
					label='Active child'
					singlePrefix='Active child'
					variant='native'
				/>

				<div className='ordering-meta'>
					<div className='ordering-balance'>
						<small>Available balance</small>
						<strong>{nfRp(+selectedCustomer?.balance || 0)}</strong>
						<Link to={`/${route.accountTopUp}`} className='link'>
							Top up
						</Link>
					</div>
					<label className='ordering-date'>
						Meal date
						<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={enUS}>
							<DatePicker
								value={orderDate ? dayjs(orderDate) : null}
								onChange={(value) => {
									if (value) {
										dispatch({ type: 'cart/setOrderDate', payload: value });
									}
								}}
								closeOnSelect
								format='DD/MM/YYYY'
								slots={{ day: PastAwarePickersDay }}
								slotProps={{
									field: { clearable: false },
									textField: {
										size: 'small',
										fullWidth: true,
										inputProps: { 'aria-label': 'Meal date' },
									},
								}}
							/>
						</LocalizationProvider>
					</label>
				</div>

				<MenuServingTimePicker />
			</header>

			<main className='ordering-main'>
				<MenuChildOrdersAccordion />
				{children}
			</main>
		</>
	);
}
